<template>
    <div class="personal-loan-status-setting">
				<TemplateMenu :tab_name="'smsTemplate'"/>
        <CreateNewSmsTemplatesModal :create_new_sms_templates.sync="modals.create_new_sms_templates" :customerSubStatusList="customerSubStatusList"  v-on:closeModal="closeModal()"  />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">SMS Templates Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <SmsTemplatesTable :customerSubStatusList="customerSubStatusList"/>
        </b-container>
    </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import SmsTemplatesTable from '@/views/Configurations/SmsTemplates/SmsTemplatesTable'
import TemplateMenu from '@/views/Configurations/TemplateMenu'
import CreateNewSmsTemplatesModal from '@/views/Configurations/SmsTemplates/SmsTemplatesModals/CreateNewSmsTemplatesModal'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce
} from '@/assets/js/httpImports.js'
export default {
    components: {
        SmsTemplatesTable,
        RouteBreadCrumb,
        CreateNewSmsTemplatesModal,
				TemplateMenu
    },
    data() {
        return {
            modals: {
                create_new_sms_templates: false
            },
            customerSubStatusList: []
        }
    },
    created() {
        this.getCustomerStatus()
    },
    methods: {
        openModal() {
            this.modals.create_new_sms_templates = true;
        },
        closeModal(){
            this.modals.create_new_sms_templates = false;
        },
        getCustomerStatus() {
            axios.get(services.customer + 'customer/statuses', {headers: getHeader()})
                .then(res => {
                    this.customerSubStatusList = res.data.data
                        .filter((status) => status.group == "sub" ? status : "")
                        .sort(function(a, b) {
                            if(a.parent_status && b.parent_status){
                                if (a.parent_status < b.parent_status) {
                                    return -1;
                                }
                                if (a.parent_status > b.parent_status) {
                                    return 1;
                                }
                            }
                            return 0;
                        })
                    this.customerStatusList = res.data.data
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            },
        }
}
</script>